import React, { useMemo, useState } from "react";
import {makeStyles, Select} from "@material-ui/core";
import {highlightColorRGBA} from "./HighlightColor";
import useReactiveFunctionWithDebouncing from "./useReactiveFunctionWithDebouncing";

const useStyles = makeStyles((theme) => ({
  maintainBorderStylesWhenHighlighted: {
    overflow: 'hidden',
  }
}));

export default function HighlightableSelect({ isHighlightedFunction, safeToHighlight = true, inputProps, className, ...props }) {
  const { value } = props;
  const [highlighted, setHighlighted] = useState(isHighlightedFunction(value));
  const classes = useStyles();
  
  const inputPropsOverride = useMemo(() => ({
    ...inputProps,
    style: {
      ...inputProps?.style,
      backgroundColor: highlighted ? highlightColorRGBA : inputProps?.style?.backgroundColor,
    }
  }), [highlighted, inputProps]);
  
  useReactiveFunctionWithDebouncing({
                              functionn: isHighlightedFunction,
                              reactiveArgument: value,
                              safeToRun: safeToHighlight,
                              setReturnedValue: setHighlighted,
                              noDebouncing: true
                            });
  
  
  return (
    <Select {...props} className={`${className ?? ''} ${classes.maintainBorderStylesWhenHighlighted}`} inputProps={inputPropsOverride} />
  );
}